export const LoginManagementRoutes = {
    ROOT: "/login-management",
    CARDTAN: "/login-management/cardTan",
    SID: "/login-management/sid",
    GID: "/login-management/gid",
};


// WEBPACK FOOTER //
// ./src/components/loginManagement/LoginManagementRoutes.ts